import type {LabeledIdentified, Rec} from 'src/typings';
import type {Citation, CitationCitacePro} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';

export class CitationDataService {
    public static serviceName = 'citationDataService';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {}

    public async getCitation(record: Rec, style?: LabeledIdentified<string>): Promise<Citation | CitationCitacePro> {
        return this.ajaxService
            .createRequest(`records/${record.id}/citation`)
            .get(transferify({style}));
    }
}